// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"156":"2ba3185b","875":"fdea213d"}[chunkId] + ".css";
};